import { HTML5Backend } from "react-dnd-html5-backend-latest";
import TouchBackend from "react-dnd-touch-backend";

let Backend = HTML5Backend;
if ("ontouchstart" in window || navigator.maxTouchPoints) {
    Backend = TouchBackend({ enableMouseEvents: true });
}

export default Backend;
